// Divisões da liga: Café com Leite, Parceiro, Malandro, Brabo e Zap. As quatro primeiras têm os níveis III, II e I,
// com 100 pontos de divisão (PD) cada; o Zap não tem nível nem teto e ordena por PD. O jogador desce de nível,
// mas não desce de divisão dentro da temporada. Os nomes não usam Bronze, Prata e Ouro, que são planos.

export const DIVISOES = [
  { id: 'cafe_com_leite', nome: 'Café com Leite', emoji: '☕' },
  { id: 'parceiro', nome: 'Parceiro', emoji: '🤝' },
  { id: 'malandro', nome: 'Malandro', emoji: '🎩' },
  { id: 'brabo', nome: 'Brabo', emoji: '🔥' },
  { id: 'zap', nome: 'Zap', emoji: '♣️' },
] as const;
export type IdDivisao = (typeof DIVISOES)[number]['id'];

export const PD_POR_NIVEL = 100;
export const NIVEIS = 3; // III, II e I
export const ULTIMA = DIVISOES.length - 1; // o Zap
const ROMANOS = ['III', 'II', 'I'] as const;

// divisao: índice em DIVISOES. pd: pontos dentro da divisão (0 a 299 nas quatro primeiras; sem teto no Zap).
export interface EstadoDivisao {
  divisao: number;
  pd: number;
}

export const INICIAL: EstadoDivisao = { divisao: 0, pd: 0 }; // Café com Leite III

export function nivelDe(e: EstadoDivisao): number | null {
  return e.divisao === ULTIMA ? null : Math.min(NIVEIS - 1, Math.floor(e.pd / PD_POR_NIVEL));
}

export function rotuloDaDivisao(e: EstadoDivisao): string {
  const nivel = nivelDe(e), nome = DIVISOES[e.divisao]!.nome;
  return nivel === null ? nome : `${nome} ${ROMANOS[nivel]}`;
}

// Barra de progresso: PD dentro do nível atual e quanto falta para o próximo (no Zap, só o total).
export function progresso(e: EstadoDivisao): { pd: number; meta: number | null } {
  const nivel = nivelDe(e);
  return nivel === null ? { pd: e.pd, meta: null } : { pd: e.pd - nivel * PD_POR_NIVEL, meta: PD_POR_NIVEL };
}

// Soma (ou tira) PD. Passar do nível I sobe de divisão e começa no nível III; perder PD desce de nível, nunca de divisão.
export function aplicarPD(e: EstadoDivisao, delta: number): EstadoDivisao & { subiu: boolean } {
  let { divisao, pd } = e;
  pd = Math.max(0, pd + delta);
  let subiu = false;
  while (divisao < ULTIMA && pd >= NIVEIS * PD_POR_NIVEL) {
    pd -= NIVEIS * PD_POR_NIVEL;
    divisao++;
    subiu = true;
  }
  return { divisao, pd, subiu };
}

// A divisão como as telas mostram: nome, emoji, rótulo com o nível e a barra de progresso.
export function divisaoNaTela(e: EstadoDivisao) {
  const d = DIVISOES[e.divisao]!;
  return { divisao: e.divisao, pd: e.pd, id: d.id as IdDivisao, nome: d.nome as string, emoji: d.emoji as string, rotulo: rotuloDaDivisao(e), progresso: progresso(e) };
}
export type DivisaoNaTela = ReturnType<typeof divisaoNaTela>;
